import { UploadFile } from "antd";

export const formatAcceptedFormats = (acceptedMimeTypes: string): string => {
  const formats = acceptedMimeTypes
    .split(", ")
    .filter((type) => !type.includes("/"))
    .map((type) => {
      return /\.\w+/.exec(type)?.[0]?.toUpperCase().slice(1);
    });
  const uniqFormats = Array.from(new Set(formats));
  return uniqFormats.join(", ");
};

export const getFileExtensionFromFileName = (fileName: string): string => {
  return fileName.split(".").pop()?.toLowerCase();
};

export const isAcceptedFormat = (
  file: UploadFile,
  acceptedMimeTypes: string
): boolean => {
  const formatsArray = acceptedMimeTypes.toLowerCase().split(", ");
  const fileType = file?.type ?? formatsArray[0];
  const mimeTypeValid = formatsArray.includes(fileType.toLowerCase());
  // If the MIME type is not valid, check if the file extension matches an accepted format
  if (!mimeTypeValid && file?.name) {
    const extension = getFileExtensionFromFileName(file.name);
    return formatsArray.includes(`.${extension}`);
  }
  return mimeTypeValid;
};
